export default function OverridesPagination() {
  return {
    MuiPagination: {
      defaultProps: {
        shape: 'rounded',
      },
      styleOverrides: { ul: { rowGap: 6 } },
    },
  };
}
